export const ROOTS_IDS_USING_SPRINKLR_CHAT = [
  411196, 312748, 315456, 317160, 317182, 317196, 336061, 336062, 339193,
  351807, 381223, 390663, 392164, 448375, 450110, 450111, 450112, 456595,
  456596, 456597, 456598, 456599, 456600, 456601, 456602, 456603, 456604,
  456607, 456608, 456609, 456610, 456611, 456612, 456613, 456614, 456615,
  456616, 456617, 456618, 456619, 456620, 456621, 456622, 456624, 456625,
  456626, 456627, 456628, 456629, 456632, 456633, 456634, 456635, 456637,
  456638, 456639, 456640, 456641, 456642, 456644, 456645, 456646, 456647,
  456649, 456650, 456652, 456655, 456657, 456660, 456663, 456665, 456666,
  456667, 456669, 456670, 456671, 456672, 456673, 456674, 456675, 456676,
  456677, 456678, 456680, 456681, 456682, 456684, 456685, 456686, 456687,
  456689, 456691, 456692, 456693, 456694, 456696, 456697, 456698, 456699,
  456700, 456701, 456703, 456705, 456707, 456708, 456709, 456711, 456712,
  456713, 456714, 456716, 456718, 456719, 456720, 456721, 456723, 456724,
  456725, 456726, 456727, 456728, 456729, 456730, 456731, 456732, 456733,
  456734, 456735, 456737, 456738, 456739, 456740, 456741, 456742, 456743,
  456744, 456745, 456746, 456750, 456751, 456752, 456753, 456754, 456755,
  456756, 456757, 456758, 456759, 456760, 456761, 456762, 456763, 456764,
  456765, 456766, 456767, 456768, 456769, 456771, 456772, 456773, 456774,
  456776, 456777, 456778, 456779, 456780, 456781, 456782, 456783, 456784,
  456785, 456786, 456787, 456788, 456789, 456792, 456793, 456795, 456796,
  456797, 456798, 456799, 456800, 456801, 456802, 456803, 456804, 456805,
  456806, 456807, 456808, 456809, 456810, 456811, 456812, 456814, 456815,
  456816, 456817, 456818, 456819, 459018, 459020, 459021
]
